import _ from 'lodash';
import {createSelector} from 'reselect';

import {tryParseUrl} from '../../../../libs/shared/helpers/src/browser/urlHelpers';
import {AppState} from '../../appState';
import {getUserId} from '../teammates/teammatesSelectors';

/** Get the map of all plugins. */
export function getPlugins(state: AppState) {
  return state.data.plugins;
}

/** Get a flat list of all plugins the user has access to. */
export const getFlatPluginsForUser = createSelector([getPlugins, getUserId], (plugins, userId) =>
  _(plugins)
    .values()
    .compact()
    // Valid plugins.
    .filter((p) => Boolean(tryParseUrl(p.endpoint)))
    // Plugins that our user should see.
    .filter((p) => !p.ownerId || p.ownerId === userId)
    .sortBy((p) => p.name)
    .value(),
);
